module.exports = __webpack_public_path__ + "img/scrmNum2.659a78f9.png";